import Vue from "vue";
import Component from "vue-class-component";

@Component
export class WebsiteUrl extends Vue {
  get $m_websiteUrl() {
    let url =
      this.$i18n.locale === "en"
        ? this.$constant.META_URL_EN
        : this.$constant.META_URL_BM;
    return url + "?v=" + new Date().getTime();
  }

  get $m_currentUrl() {
    return window.location.origin + this.$constant.BASE_ROUTE;
    // let url =
    //   this.$i18n.locale === "en"
    //     ? this.$constant.META_URL_EN
    //     : this.$constant.META_URL_BM;
    // return url + "?v=" + new Date().getTime();
  }

  get $m_des() {
    return `Join Nothing Really Mattress Contest to reward yourself a chance to win exclusive IKEA cash vouchers worth RM23,000! Stay tuned for our weekly announcements if you have submitted your entries. View ${this.$m_currentUrl} for more information.`;
  }
}
